<template>
  <div>
    <h4 class="c-blue-text title-font tw-text-sm">Top Benefits</h4>
    <div class="tw-flex tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-mt-3 c-blue-text tw-text-center tw-px-2 tw-capitalize">
      <div class="tw-flex tw-flex-col tw-justify-center">
        <img src="/images/icons/hospitalization.png" class="tw-object-none tw-object-center" alt="tow">
        <small class="c-gray-text">Hospitalisation Cash</small>
        <p class="tw-text-xs">
          1st 48 hours covered up to Ksh 100,000
        </p>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-2">
        <img src="/images/icons/radio.png" class="tw-object-none tw-object-center" alt="tow">
        <small class="tw-mt-2 c-gray-text">Entertainment</small>
        <p class="tw-text-xs">Ksh 50,000</p>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-2">
        <img src="/images/icons/screen.png" class="tw-mt-0 md:tw-mt-3 tw-object-none tw-object-center" alt="tow">
        <small class="tw-mt-0 md:tw-mt-3 c-gray-text">Windscreen</small>
        <p class="tw-text-xs">Ksh 50,000</p>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-2">
        <img src="/images/icons/violence.png" class="tw-object-none tw-object-center" alt="tow">
        <small class="tw-mt-2 c-gray-text">Political Violence & Terrorism</small>
        <p class="tw-text-xs">Value of the vehicle</p>
      </div>
    </div>

    <h4 class="c-blue-text title-font tw-text-sm">Other Benefits</h4>
    <div class="tw-flex tw-grid tw-grid-cols-1
                 md:tw-grid-cols-2">
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/harm.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Legal defence</small>
          <p class="tw-text-xs c-blue-text">Free limit KSH 50,000</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/cross.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Medical expenses</small>
          <p class="tw-text-xs c-blue-text">Free limit KSH 50,000</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/hit.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Third party property damage</small>
          <p class="tw-text-xs c-blue-text">Free</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/repair.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Authorized Repair Limit</small>
          <p class="tw-text-xs c-blue-text">Free for KSH 30,0000/=</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/no-blame-excess.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">No Blame No Excess</small>
          <p class="tw-text-xs c-blue-text">Free</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/excess-protector.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Excess Protector</small>
          <p class="tw-text-xs c-blue-text">Free</p>
        </div>
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-mt-3">
      <img src="/images/icons/car1.png" class="tw-w-12 tw-h-12" alt="tow">
      <div class="tw-ml-3">
        <small class="tw-mt-2 c-gray-text">Free Third party person liability</small>
        <ul class="tw-list-disc pl-0 tw-text-xs c-blue-text tw-gap-4">
          <li>Third Party Personal Injury Limit: Ksh 3,000,000/=</li>
          <li>Third Party Property Damage Limit: Ksh 3.000,000/=</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BimaBambaBenefits',
};
</script>
